import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SeoMetadata {
  seoTitle: string | null;
  metaDescription: string | null;
  ogTitle: string | null;
  ogDescription: string | null;
  ogImage: string | null;
  canonicalUrl: string | null;
  noindex: boolean;
  jsonld: unknown[] | null;
}

const fetchSeoMetadata = async (pageSlug: string): Promise<SeoMetadata | null> => {
  const { data, error } = await supabase
    .from("seo_metadata")
    .select("seo_title, meta_description, og_title, og_description, og_image, canonical_url, noindex, jsonld")
    .eq("page_slug", pageSlug)
    .maybeSingle();

  if (error || !data) return null;

  return {
    seoTitle: data.seo_title || null,
    metaDescription: data.meta_description || null,
    ogTitle: data.og_title || null,
    ogDescription: data.og_description || null,
    ogImage: data.og_image || null,
    canonicalUrl: data.canonical_url || null,
    noindex: data.noindex ?? false,
    jsonld: Array.isArray(data.jsonld) ? data.jsonld : null,
  };
};

export function useSeoMetadata(pageSlug?: string) {
  return useQuery({
    queryKey: ["seo-metadata", pageSlug],
    queryFn: () => fetchSeoMetadata(pageSlug!),
    enabled: pageSlug !== undefined,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
